/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Dietician_TitleInputs */

const en_for_whom_dietician_title = /** @type {(inputs: For_Whom_Dietician_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A meal plan that lives on their phone.`)
};

const pl_for_whom_dietician_title = /** @type {(inputs: For_Whom_Dietician_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadłospis, który żyje w telefonie.`)
};

/**
* | output |
* | --- |
* | "A meal plan that lives on their phone." |
*
* @param {For_Whom_Dietician_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_dietician_title = /** @type {((inputs?: For_Whom_Dietician_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Dietician_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_dietician_title(inputs)
	return en_for_whom_dietician_title(inputs)
});